import moment from "moment"
import { URL_DATE_FORMAT } from "src/containers/Calendar/constants"

// Calendar
export const CALENDAR_URL = `/calendar`
export const CALENDAR_EVENT_URL = `/calendar/:scale/:date/events/:id`
export const CALENDAR_DATE_URL = `/calendar/:scale/:date`

export const CALENDAR_REDIRECT_URL = `/calendar/month/${moment().format(
  URL_DATE_FORMAT,
)}`
export const getPlanRedirectUrl = (start, end) => {
  const d = new Date()
  const currentDay = d.getTime()
  return `/calendar/month/${moment(
    currentDay > end ? start : currentDay,
  ).format(URL_DATE_FORMAT)}`
}

export const DEFAULT_ID_VALIDATION_CONFIG = [{ type: `id`, index: 1 }]
export const DEFAULT_UUID_VALIDATION_CONFIG = [{ type: `uuid`, index: 1 }]

// Plans
export const PLANS_URL = `/plans`
export const PLAN_UUID_URL = `/plan-by-uuid/:uuid`
export const PLANS_ID_URL = `/plans/:id`
export const PLANS_BY_UUID_URL = `/plan-by-uuid/:uuid`
export const PLANS_ID_URL_VALIDATION_CONFIG = [{ type: `id`, index: 1 }]
export const PLANS_ID_CALENDAR_URL = `/plans/:planId/calendar`
export const PLANS_ID_MAIN_URL = `/plans/:id/main`
export const PLANS_ID_RESOURCES_URL = `/plans/:id/resources`
export const PLANS_ID_CONSTRAINT_URL = `/plans/:id/constraint`

// TODO add scale and date validation
export const PLANS_ID_CALENDAR_DATE_URL = `/plans/:planId/calendar/:scale/:date`
export const PLANS_ID_CALENDAR_DATE_REDIRECT_URL = `/plans/:planId/calendar/day/${moment().format(
  URL_DATE_FORMAT,
)}`
export const PLANS_ID_CALENDAR_SETTINGS_URL = `/plans/:planId/calendar/:scale/:date/settings`
export const PLANS_ID_CALENDAR_EVENT_URL = `/plans/:planId/calendar/:scale/:date/events/:id`
export const PLANS_ID_CALENDAR_EVENT_URL_VALIDATION_CONFIG = [
  { type: `id`, index: 1 },
  { type: `uuid`, index: 6 },
]
export const PLANS_ID_CALENDAR_EVENTS_URL = `/plans/:planId/calendar/:scale/:date/planEvents`
export const PLANS_ID_CALENDAR_MAIN_URL = `/plans/:planId/calendar/:scale/:date/settings/main`
export const PLANS_ID_CALENDAR_RESOURCES_URL = `/plans/:planId/calendar/:scale/:date/settings/resources`
export const PLANS_ID_CALENDAR_CONSTRAINT_URL = `/plans/:planId/calendar/:scale/:date/settings/constraint`

// Plan Types
export const PLAN_TYPES_URL = `/plan-types`
export const PLAN_TYPES_ID_URL = `/plan-types/:id`
export const PLAN_TYPES_ID_MAIN_URL = `/plan-types/:id/main`
export const PLAN_TYPES_ID_CONSTRAINT_URL = `/plan-types/:id/constraint`

// Events
export const EVENTS_URL = `/events`
export const EVENTS_ID_URL = `/events/:id`
export const EVENTS_ID_URL_VALIDATION_CONFIG = [{ type: `uuid`, index: 1 }]
export const EVENT_CALENDAR_UUID_VALIDATION_CONFIG = [
  { type: `uuid`, index: 4 },
]

// Event Types
export const EVENT_TYPES_URL = `/event-types`
export const EVENT_TYPES_ID_URL = `/event-types/:id`

// Resources
export const RESOURCES_URL = `/resources`
export const RESOURCES_ID_URL = `/resources/:id`
export const RESOURCES_ID_URL_VALIDATION_CONFIG = [{ type: `uuid`, index: 1 }]

// Resource Types
export const RESOURCE_TYPES_URL = `/resource-types`
export const RESOURCE_TYPES_ID_URL = `/resource-types/:id`

// Report templates
export const REPORT_TEMPLATES_URL = `/report-templates`
export const REPORT_TEMPLATES_ID_URL = `/report-templates/:id`

// Roles
export const ROLES_URL = `/roles`
export const ROLES_ID_URL = `/roles/:id`
